import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Bell } from "lucide-react";
import { RED_COLOR } from "../../utils/colors";

const BELL_ICON_SIZE = 20;
const BELL_ICON_STROKE_WIDTH = 2;

const BELL_BUTTON_SX = {
  p: 0,
  m: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "inherit",
  "&:hover": {
    backgroundColor: "transparent",
  },
};

const BADGE_SX = {
  "& .MuiBadge-badge": {
    minWidth: 8,
    height: 8,
    padding: 0,
    top: 3,
    right: 5,
    backgroundColor: RED_COLOR,
  },
};

const GlobalAlertsBellButton = ({ hasUnread = false, onClick, label, id }) => (
  <Tooltip title={label}>
    <IconButton
      id={id}
      onClick={onClick}
      aria-label={label}
      sx={BELL_BUTTON_SX}
    >
      <Badge
        variant="dot"
        color="error"
        overlap="circular"
        invisible={!hasUnread}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={BADGE_SX}
      >
        <Bell size={BELL_ICON_SIZE} strokeWidth={BELL_ICON_STROKE_WIDTH} />
      </Badge>
    </IconButton>
  </Tooltip>
);

export default GlobalAlertsBellButton;
